import EntityPage from "@/components/EntityPage";
import { CP_STATUS, CP_TIPE } from "@/lib/status";

// `koordinat` sengaja satu kolom teks bebas, bukan dua kolom angka: itu hasil ukuran lapangan
// yang diketik apa adanya. Kolom ini WAJIB dan menjadi sumber posisi — `geom` diturunkan darinya
// (node-backend/koordinat.js + crud.js `titik`), jadi mengubah teks memindahkan titik di peta.
// Formatnya hanya "Lat Long": Height masih diterima di parser (lembar ukur lama) lalu dibuang.
// Pemisah `;` dan `,` diterima dan disimpan sebagai spasi, jadi format tampil hanya satu.
// `hint` memberi contoh urutannya, karena label saja tidak memberi tahu mana latitude.
// `tipe` memakai type "status": di form itu berarti Select berisi `options` tetap, dan di tabel
// berarti badge berwarna — persis yang diinginkan untuk kolom berisi dua nilai baku.
// `cp_id` membawa `bisaUbahId`: nomor titik datang dari lembar ukur, jadi salah ketik harus bisa
// diperbaiki. Itu satu-satunya ID bisnis yang bisa diedit — Flight dan Grid tetap terkunci.
// `tanggal_ukur` membawa `hariIni`: form baru terisi tanggal hari ini (WIB) dan hanya boleh mundur.
const COLUMNS = [
  { key: "cp_id", label: "ID CP", type: "text", bisaUbahId: true },
  { key: "status", label: "Status", type: "status", options: CP_STATUS },
  { key: "koordinat", label: "Koordinat (Lat Long)", type: "text", hint: "mis. -7.008100 110.415200", wajib: true },
  { key: "tipe", label: "Tipe", type: "status", options: CP_TIPE },
  { key: "tanggal_ukur", label: "Tanggal Ukur", type: "date", hariIni: true },
  // Kolom `elevasi` pensiun: tidak ada di daftar ini, dan juga tidak ada di `fields` router
  // `/api/control-points` — nilainya tetap tersimpan di DB tapi tidak lagi dipertukarkan.
];

// Edit-only seperti Tabular Grid: daftar CP berasal dari hasil pengukuran, bukan input manual,
// jadi tombol Tambah dan Hapus dimatikan. Rutenya sendiri tetap hidup di server (crudRouter selalu
// memount POST dan DELETE) — edit-only murni keputusan UI, sama seperti Grids.
export default function ControlPointsPage() {
  return <EntityPage title="Control Point" eyebrow="Modul 03 · Tabular CP" endpoint="/control-points" prefix="cp" columns={COLUMNS} filterKey="status" layerKey="control-points" canCreate={false} canDelete={false} />;
}
